import {
  normalize_key,
  normalize_text,
  to_number,
} from './company_cases_helpers';

const ROUTE_CASE_ROLE_KEYS = new Set([
  'system-admin',
  'company-admin',
  'coordinator',
]);

export function can_create_case(component) {
  const has_entity_type = Boolean(to_number(component.new_case_form.entity_type_id));
  const has_description = Boolean(normalize_text(
    component.new_case_form.description || component.new_case_form.requester
  ));
  const preview_ready = Boolean(component.onboarding_preview);
  return [
    has_entity_type,
    has_description,
    preview_ready,
    !component.onboarding_preview_loading,
  ].every(Boolean);
}

export function can_route_case(component) {
  const role_key = normalize_key(component.current_role);
  return ROUTE_CASE_ROLE_KEYS.has(role_key) || role_key.includes('coordinator');
}
